package com.karawek.core.auth.usecase

import com.karawek.core.auth.api.Authenticator
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class RegisterPasskeyUseCase(
    private val authenticator: Authenticator,
) {
    suspend operator fun invoke(): Result<Unit> =
        authenticator.registerPasskey()
}
